import { createBrowserRouter } from "react-router-dom";
import { HomePage } from "../pages/home/home";
import React from "react";
import { PrivateRoute } from "../pages/private/privateRoute"; // Adjust the path as necessary
import { LoginPage } from "../pages/Login/login";
import ProfilePage from "../pages/profile/profilePage";
import { GSMList } from "../pages/gsm/partials/gsmList";
import { ContactPage } from "../pages/contact/contact"; // Adjust the path as necessary
import { GSM } from "../pages/gsm/partials/gsmDetail";
import { GsmEdit } from "../pages/gsm/partials/gsmEdit";
import AddGsm from "../pages/gsm/partials/addGsm";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivateRoute />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "profile/:uid", element: <ProfilePage /> },
      { path: "gsm", element: <AddGsm /> },
      { path: "overzicht", element: <GSMList /> },
      {
        path: "gsm/:id",
        element: <GsmEdit />,
      },
      { path: "contact", element: <ContactPage /> },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
]);
